"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayValue = void 0;
var react_1 = __importDefault(require("react"));
var R = __importStar(require("../utils/ramda"));
var isType_1 = require("../utils/isType");
function getDisplayValue(value, dateFormatFn, noValue) {
  if (dateFormatFn === void 0) {
    dateFormatFn = function (v) {
      return v.toString();
    };
  }
  if (noValue === void 0) {
    noValue = "<!NOVALUE>";
  }
  if (R.isNil(value)) return noValue;
  if (react_1.default.isValidElement(value)) return value;
  if ((0, isType_1.isDate)(value)) return dateFormatFn(value);
  if ((0, isType_1.isSymbol)(value)) return value.toString();
  if ((0, isType_1.isObject)(value)) return JSON.stringify(value);
  if ((0, isType_1.isFunction)(value)) return "<!FUNCTION>";
  return "".concat(value);
}
exports.getDisplayValue = getDisplayValue;